import { __ } from 'i18n/translate';
import api from '../services/api';
import { MetaPaging, MetaTemplate } from 'types';

export type GetTemplatesResponse = {
    data: MetaTemplate[];
    paging: MetaPaging;
};

export type ComponentsParametersType = {
    type: string;
    text?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};
export type TemplateComponentsType = {
    type: string;
    parameters: ComponentsParametersType[];
};

export const getMetaTemplates = (
    cursor?: string,
    whatsappId?: number
): Promise<GetTemplatesResponse> => {
    return api
        .get('/meta/getTemplates', { params: { cursor, whatsappId } })
        .then(({ data }) => data);
};

export const sendTemplate = (
    templateName: string,
    ticketUUID: string,
    components?: TemplateComponentsType[]
): Promise<void> => {
    return api.post(`/messages/sendTemplate/${ticketUUID}`, {
        templateName,
        components: components
    });
};

export const uploadMedia = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('media', file);
    const result = await api.post('/meta/templateMedia', formData, {
        validateStatus: () => true
    });
    if (result.status === 200) {
        return result.data.result;
    }
    throw __('messageTemplateForm.uploadError');
};

export const mediaFromCache = (file: File) => {
    const formData = new FormData();
    formData.append('media', file);
    return api
        .post('/meta/mediaFromCache', formData)
        .then(({ data }) => data.link);
};

export type PhoneQualityRating = 'GREEN' | 'YELLOW' | 'RED' | 'UNKNOWN';

export type GetPhoneQualityResponse = {
    id: string;
    quality_rating: PhoneQualityRating;
};

export const getPhoneQuality = (
    whatsappId: number
): Promise<GetPhoneQualityResponse> => {
    return api
        .get('/meta/phoneQuality', { params: { whatsappId } })
        .then(({ data }) => data);
};

/**
 * Re-registra o número na Cloud API. O fluxo normal é automático (webhook
 * `phone_number_name_update`); isto é a saída manual quando ele falha, por
 * exemplo com o PIN de verificação em duas etapas trocado no WhatsApp Manager.
 */
export const registerOfficialNumber = (
    whatsappId: number,
    pin?: string
): Promise<void> => {
    return api
        .post('/meta/registerNumber', { whatsappId, pin })
        .then(({ data }) => data);
};

export const deleteMetaTemplate = (
    whatsappId: number,
    templateName: string
): Promise<void> => {
    return api.delete('/meta/template', {
        params: { whatsappId, name: templateName }
    });
};
